import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const SignupModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "SignupModalContainer" */
      './SignupModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
